<script lang="ts">
  import { isHaveFixedNews } from '../../store'
  import {isDirtySearch, isHaveNews, isShowSearchLoader} from '../../../../stores'
  import { _ } from 'svelte-i18n'

  import NoItemsBanner from '../../../../custom/NoItemsBanner.svelte'
</script>

{#if !$isShowSearchLoader && !$isHaveNews && !$isHaveFixedNews && !$isDirtySearch}
  <NoItemsBanner 
    title="{$_('nothingToSeeHere')}"
    subtitle="{$_('contentComingSoon')}"
    background="/static/no-items.jpeg" 
  />
{/if}